// tslint:disable
import {
  COMMERCIAL_LIST_PROVIDER_KEY,
  OPENED_LIST_DATA_PROVIDER_KEY,
} from '@epicuro-next/data-providers/providers-registry';
import { LogicOperator } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import {
  listDescriptionItem,
  listDescriptionMarkdownItem,
} from '../items/list-description-item';
import { listNameNonEditableItem } from '../items/list-name-item';

import { listProductsConfigDefault } from '../items/list-products.config';
import { mediaCommercialConfigDefault } from '../items/media.config';
import {
  dynamicCollectionRendererKey,
  dynamicElementsIconKey,
} from '@epicuro-next/constants/dynamic-elements';

export const defaultDetailsCommercial = (useMarkdownDescription = false) => ({
  styles: { classes: ['container-fluid', 'mt-3'] },
  items: [
    {
      // header wrapper
      contentTypeId: dynamicCollectionRendererKey,
      styles: {
        classes: ['row', 'align-items-center', 'no-gutters', 'my-3'],
      },
      inputs: {
        items: [
          {
            contentTypeId: dynamicCollectionRendererKey,
            styles: {
              classes: [
                'col-12',
                'mr-3',
                'position-relative',
                'overflow-hidden',
              ],
              style: {
                'max-height': '40rem',
              },
            },
            inputs: {
              items: [
                {
                  ...mediaCommercialConfigDefault,
                  styles: {
                    classes: ['inset-cover', 'w-100', 'h-100'],
                  },
                },
                // header container
                {
                  contentTypeId: dynamicCollectionRendererKey,
                  styles: {
                    classes: [
                      'd-flex',
                      'justify-content-center',
                      'px-3',
                      'py-5',
                      'p-md-4',
                    ],
                  },
                  inputs: {
                    items: [
                      // header wrapper
                      {
                        contentTypeId: dynamicCollectionRendererKey,
                        styles: {
                          classes: [
                            'position-relative',
                            'p-4',
                            'p-md-5',
                            'overflow-hidden',
                          ],
                          style: {
                            'border-radius': '1.25rem',
                            'z-index': '1',
                            'flex-grow': '1',
                            'max-width': '51rem',
                          },
                        },
                        inputs: {
                          items: [
                            {
                              contentTypeId: dynamicCollectionRendererKey,
                              styles: {
                                classes: ['position-absolute'],
                                style: {
                                  opacity: '0.85',
                                  top: '0',
                                  left: '0',
                                  width: '100%',
                                  height: '100%',
                                  'z-index': '-1',
                                  'background-color':
                                    'var(--body-bg, var(--color-brand-white, #ffffff))',
                                },
                              },
                            },
                            // card content
                            {
                              contentTypeId: dynamicCollectionRendererKey,
                              styles: {
                                classes: ['d-flex', 'flex-column'],
                              },
                              inputs: {
                                items: [
                                  //adjustItemsLabelTpl
                                  {
                                    contentTypeId: dynamicCollectionRendererKey,
                                    if: [
                                      LogicOperator.EQ,
                                      [
                                        {
                                          provider:
                                            COMMERCIAL_LIST_PROVIDER_KEY,
                                          property: 'isDocumentControlEnabled',
                                        },
                                        true,
                                      ],
                                    ],
                                    styles: {
                                      classes: [
                                        'ml-auto',
                                        'font-weight-medium',
                                        'd-md-flex',
                                        'align-items-center',
                                        'px-3',
                                        'd-none',
                                      ],
                                      style: {
                                        'background-color':
                                          'var(--color-brand-gray-300, #f5f5f5)',
                                        color:
                                          'var(--color-brand-gray-800, #777777)',
                                        'border-radius':
                                          'var(--border-radius-sm, 0.125rem)',
                                        'margin-top': '-1.25rem',
                                        height: '2.065rem',
                                        'line-height': '1.5rem',
                                      },
                                    },
                                    inputs: {
                                      items: [
                                        {
                                          contentTypeId: dynamicElementsIconKey,
                                          inputs: {
                                            icon: ['fas', 'box'],
                                            size: 's',
                                          },
                                          styles: {
                                            classes: ['mr-2'],
                                          },
                                        },
                                        {
                                          contentTypeId: 'dynamic-text',
                                          if: [
                                            LogicOperator.EQ,
                                            [
                                              {
                                                provider:
                                                  COMMERCIAL_LIST_PROVIDER_KEY,
                                                property: 'adjustNumberOfItems',
                                              },
                                              'only-upwards',
                                            ],
                                          ],
                                          inputs: {
                                            text: '@@commercialListHeaderCustomisableUpwardsLabel',
                                          },
                                        },
                                        {
                                          contentTypeId: 'dynamic-text',
                                          if: [
                                            LogicOperator.EQ,
                                            [
                                              {
                                                provider:
                                                  COMMERCIAL_LIST_PROVIDER_KEY,
                                                property: 'adjustNumberOfItems',
                                              },
                                              true,
                                            ],
                                          ],
                                          inputs: {
                                            text: '@@commercialListHeaderFixedDealLabel',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  // row (hot-list + list name + shareList)
                                  {
                                    contentTypeId: dynamicCollectionRendererKey,
                                    styles: {
                                      classes: [
                                        'mb-2',
                                        'd-inline-flex',
                                        'align-items-center',
                                      ],
                                    },
                                    inputs: {
                                      items: [
                                        {
                                          contentTypeId:
                                            'dynamic-hot-list-indicator',
                                          inputs: {
                                            listIds: {
                                              provider:
                                                OPENED_LIST_DATA_PROVIDER_KEY,
                                              property: 'id',
                                            },
                                            showAlmostHotIconBasedOnUserRole:
                                              true,
                                          },
                                        },
                                        {
                                          ...listNameNonEditableItem,
                                          styles: {
                                            variables: {
                                              '--text-editable-dynamic-font-size':
                                                '1.75rem',
                                              '--text-editable-dynamic-font-weight':
                                                '500',
                                              '--text-editable-dynamic-sm-font-size':
                                                'calc(1.3rem + 0.6vw)',
                                            },
                                          },
                                        },
                                        {
                                          contentTypeId:
                                            'dynamic-elements-button',
                                          styles: {
                                            classes: ['btn-light', 'ml-2'],
                                            variables: {
                                              '--btn-dynamic-padding': '0',
                                              '--btn-dynamic-width':
                                                '1.6875rem',
                                              '--btn-dynamic-height':
                                                '1.6875rem',
                                              '--btn-dynamic-icon-width':
                                                '1.6875rem',
                                              '--btn-dynamic-icon-height':
                                                '1.6875rem',
                                              '--btn-dynamic-icon-font-size':
                                                '0.75rem',
                                              '--btn-dynamic-display': 'flex',
                                              '--btn-dynamic-justify-content':
                                                'center',
                                              '--btn-dynamic-align-items':
                                                'center',
                                            },
                                            style: {
                                              'border-radius': '50%',
                                            },
                                          },
                                          inputs: {
                                            icon: ['fas', 'link'],
                                            action: 'share-list',
                                            tooltip: 'copyLinkTooltip',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  getCommercialDescription(
                                    useMarkdownDescription,
                                  ),
                                  {
                                    contentTypeId: 'dynamic-elements-author',
                                    inputs: {
                                      user: {
                                        provider: 'OpenedListDataProvider',
                                        property: 'creation.user',
                                      },
                                      date: {
                                        provider: 'OpenedListDataProvider',
                                        property: 'update.dateUtc',
                                      },
                                    },
                                  },
                                  {
                                    contentTypeId:
                                      'dynamic-shop-the-commercial-list',
                                    inputs: {
                                      list: {
                                        provider: COMMERCIAL_LIST_PROVIDER_KEY,
                                        property: 'list',
                                      },
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      contentTypeId: dynamicCollectionRendererKey,
      styles: {
        classes: ['row', 'mt-4'],
      },
      inputs: {
        items: [
          {
            contentTypeId: dynamicCollectionRendererKey,
            styles: {
              classes: ['col-12'],
            },
            inputs: {
              items: [
                {
                  ...listProductsConfigDefault,
                  children: [],
                },
              ],
            },
          },
        ],
      },
    },
  ],
});

function getCommercialDescription(useMarkdownDescription = false) {
  const description = useMarkdownDescription
    ? listDescriptionMarkdownItem
    : listDescriptionItem;

  return {
    ...description,
    styles: {
      classes: ['text-muted', 'justify-content-start', 'mb-3'],
    },
  };
}
